<template>
  <div id="app">
    <Header v-if="header === true"/>

    <div :class="['wrap', footer!==true?'wrap_n':'']" ref="wrap" id="wrap">
    <keep-alive>
      <router-view ref="index" v-if="isRouterAlive"/>
    </keep-alive>
    </div>
    <Footer v-if="footer === true"/>
    <LoginPop v-if="showlogin === true"/>
    <Dingyue v-if="ding !== null" :data="ding"/>
    <Treaty v-if="showTreaty === true"/>
    <Mianze v-if="showMianze === true"/>
  </div>
</template>

<script>
import Footer from './components/public/footer'
import LoginPop from './components/public/loginPop'
import Header from './components/public/header'
// import Title from './components/public/title'
import Dingyue from './components/public/dingyue'
import Treaty from './components/public/treatyPop'
import Mianze from './components/public/mianzePop'
import { mapGetters } from "vuex"

export default {
  name: 'App',
  computed: mapGetters(["footer", 'header', 'showlogin', 'ding', 'showTreaty', 'showMianze']),
  components: {
    LoginPop,
    Footer,
    Header,
    Dingyue,
    // Title,
    Treaty,
    Mianze
  },
  data(){
    return {
      isRouterAlive: true,
    }
  },
  provide(){
    return {
      reload: this.reload
    }
  },
  watch: {
    //监控用户信息
    // user(v){
    //   console.log(v)
    // }
  },
  methods: {
    reload(){
      // console.log('reload')
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted() {
    //console.log(this.$route)
    //const baseUrl = process.env.VUE_APP_BASE_URL
    //console.log(window.location.href)
    let url = window.location.href
    if (!this._isMobile() && url.indexOf('localhost') === -1) {
      //alert("手机端");
      if(url.indexOf('fx8788') > -1)
        window.location.href = 'http://www.fx8988.com'
      else if(url.indexOf('fx8588') > -1)
        window.location.href = 'http://www.fx8688.com'
    }
    else {
      //每次执行前，先移除上次插入的代码
      document.getElementById('LA_COLLECT') && document.getElementById('LA_COLLECT').remove();
      var hm = document.createElement("script");
      hm.src = "//sdk.51.la/js-sdk-pro.min.js?id=Jep63YayQQTyTNtN&ck=Jep63YayQQTyTNtN";
      hm.charset = 'UTF-8'
      hm.id = "LA_COLLECT"
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    }
  }
}

// npm run build
</script>

<style scoped>
  /*.wrap{height:calc(100vh - 100px);overflow-y: auto;}*/
  /*.wrap_n{height:calc(100vh - 50px);}*/
</style>
